import { Table } from '@material-ui/core'
import { DadosGarantiasSaida } from 'models/Viabilidade/GarantiasSaida'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableCellLabel, TableRowAlternada, TableCellValor } from '../index.style'

const CartaoGarantias: React.FC<{ dados: DadosGarantiasSaida }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableGarantias">
        <TableRowAlternada>
          <TableCellLabel>Fiança Bancária Terreno (R$)</TableCellLabel>
          <TableCellValor data-cy="campoFiancaBancariaTerreno">
            <NumberFormat
              value={dados?.fiancaBancariaTerreno}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Seguro Garantia Permuta Física (R$)</TableCellLabel>
          <TableCellValor data-cy="campoSeguroGarantiaPermutaFisica">
            <NumberFormat
              value={dados?.seguroGarantiaPermutaFisica}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Seguro Garantia Urbanização (R$)</TableCellLabel>
          <TableCellValor data-cy="campoSeguroGarantiaUrbanizacao">
            <NumberFormat
              value={dados?.seguroGarantiaUrbanizacao}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Corretagem de Prospecção (R$)</TableCellLabel>
          <TableCellValor data-cy="campoCorretagemProspeccao">
            <NumberFormat
              value={dados?.corretagemProspeccao}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoGarantias
